import router from './router';
import Vue from 'vue';

const npos = {
	computed: {
		todayTimeOpen: function () {
			const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
			let timeBoardClose = {};

			let date = new Date();
			let weekday = days[date.getDay() - 1];
			let json = '';
			let content = '';
			let from = '';
			let to = '';

			if (this.cause.timeboardclose !== undefined && this.cause.timeboardclose) {
				timeBoardClose = this.getNposJson(this.cause.timeboardclose);
				if (timeBoardClose[weekday] !== undefined) {
					return this.$t('today');
				}
			}

			if (this.cause.timeboard !== undefined && this.cause.timeboard) {
				try {
					json = JSON.parse(this.cause.timeboard);
				} catch (e) {
					console.log(e);
				}
				if (!json) return content;

				for (let key in json) {
					if (key.indexOf(weekday + '_end') !== -1) {
						to = json[key] ? this.$tConvert(json[key]) : '';
					}

					if (key.indexOf(weekday + '_start') !== -1) {
						from = json[key] ? this.$tConvert(json[key]) : '';
					}
				}

				return `${from}-${to}`;
			}

			return '';
		},

		price: function () {
			const from = this.cause.min_price !== undefined ? (this.cause.min_price ? '$' + this.cause.min_price : '') : '';
			const to = this.cause.max_price !== undefined ? (this.cause.max_price ? '$' + this.cause.max_price : '') : '';
			return `${this.$t('Pricing')} - ${from} ... ${to}`;
		},
		discount: function () {
			// const from =
			//     this.cause.min_discount !== undefined
			//         ? this.cause.min_discount
			//             ? this.cause.min_discount + "%"
			//             : ""
			//         : "";
			const to =
				this.cause.max_discount !== undefined ? (this.cause.max_discount ? this.cause.max_discount + '%' : '') : '';
			// return `${this.$t("Discount")} - ${from} - ${to}`;
			return `${this.$t('Discount')} - ${to}`;
		},
	},

	methods: {
		getNposContent: function (key) {
			let content = '';
			let json = '';
			if (this.cause[key] !== undefined) {
				try {
					json = JSON.parse(this.cause[key]);
				} catch (e) {
					console.log(e);
				}
				if (!json) return content;

				content = json[this.locale] !== undefined ? json[this.locale] : json['en'] !== undefined ? json['en'] : '';
			}

			return content;
		},
		getNposImage: function (url) {
			if (url) {
				return url;
			}

			return '';
		},
		getNposJson: function (json) {
			try {
				return json && JSON.parse(json);
			} catch (e) {
				console.log(e);
			}

			return '';
		},
		saveNposChoice: function (title) {
			this.$store.commit('userUpdate', { npo_title: title });
		},
		getLocalizationData: function (jsonContent) {
			let content = '';
			let json = '';

			try {
				json = JSON.parse(jsonContent);
			} catch (e) {
				console.log(e);
			}

			if (!json) return jsonContent;

			content = json[this.locale] !== undefined ? json[this.locale] : json['en'] !== undefined ? json['en'] : '';

			return content;
		},
	},
};

const helpers = {
	methods: {
		generateStyles: function () {
			let el =
				this.$refs[this.currentRefName][0] !== undefined
					? this.$refs[this.currentRefName][0]
					: this.$refs[this.currentRefName];
			if (el && el.getBoundingClientRect !== undefined) {
				let box = el.getBoundingClientRect();
				let boxParent = this.$refs.givingChooser.getBoundingClientRect();
				this.styles = {
					width: el.clientWidth + 'px',
					left: box.left - boxParent.left + 'px',
					right: 'auto',
				};
			}
		},
		checkRegisterUser: function (user) {
			if (!user.pr_npo) {
				this.$setState('loginActiveStep', 'cause');
				this.$setState('loginSteps', { signUp: true });
				this.$setState('loginOperation', 'signUp');
			} else if (!user.pr_card) {
				this.$setState('loginActiveStep', 'card');
				this.$setState('loginSteps', { cause: true, signUp: true });
				this.$setState('loginOperation', 'signUp');
			} else if (!user.pr_bank) {
				this.$setState('loginActiveStep', 'card');
				this.$setState('loginSteps', { cause: true, signUp: true });
				this.$setState('loginOperation', 'signUp');
			} else {
				router.push('/dashboard').catch((failure) => {
					console.log(failure.to.path);
				});
			}
		},
		logOutActions: function () {
			Vue.prototype.$setLocalStorage('thriveAppToken', '');
			Vue.prototype.$deleteLocalStorage('thriveAppTokenInitTime');
			Vue.prototype.$deleteLocalStorage('thriveAppTokenRemember');
			Vue.prototype.$setLocalStorage('ThriveAppLoginProcessType', 'signIn');
			Vue.prototype.$setState('user', false);
			Vue.prototype.$setState('loginSteps', {
				signUp: false,
				cause: false,
				card: false,
				finished: false,
			});
			Vue.prototype.$setState('showSteps', true);
			Vue.prototype.$setState('showAppFilters', false);
			Vue.prototype.$setState('typeAppFilter', 'map');
			Vue.prototype.$setState('showGoogleMap', false);
			Vue.prototype.$setState('loginActiveStep', 'signUp');
			Vue.prototype.$setState('loginOperation', 'signIn');
			Vue.prototype.$setState('loginShowOperationTitle', false);
			Vue.prototype.$setState('corporationReset', { is: false });

			if (window.FB !== undefined) {
				window.FB.logout(function (response) {
					console.log(response.status);
				});
			}

			router.push('/login').catch((failure) => {
				console.log(failure.to.path);
			});
		},
		logOut: function () {
			this.$http.post(`user/signout`).then((data) => {
				if (data && data.status !== undefined && data.status) {
					this.$setLocalStorage('thriveAppToken', '');
					this.$deleteLocalStorage('thriveAppTokenInitTime');
					this.$deleteLocalStorage('thriveAppTokenRemember');
					this.$setLocalStorage('ThriveAppLoginProcessType', 'signIn');
					this.$setState('user', false);
					this.$setState('loginSteps', {
						signUp: false,
						cause: false,
						card: false,
						finished: false,
					});
					this.$setState('showSteps', true);
					this.$setState('showAppFilters', false);
					this.$setState('typeAppFilter', 'map');
					this.$setState('showGoogleMap', false);
					this.$setState('loginActiveStep', 'signUp');
					this.$setState('loginOperation', 'signIn');
					this.$setState('loginShowOperationTitle', false);
					this.$setState('corporationReset', { is: false });

					if (window.FB !== undefined) {
						window.FB.logout(function (response) {
							console.log(response.status);
						});
					}

					let thriveAppReferral = this.$getLocalStorage('thriveAppReferral');
					if (this.$route.path !== '/login') {
						if (thriveAppReferral != "undefined" && thriveAppReferral != "" && thriveAppReferral != null) {
							this.$router.push(`/login?referral=${thriveAppReferral}`);
							this.$deleteLocalStorage('thriveAppReferral', '');
							this.$deleteLocalStorage("splashScreenLogo")
						} else {
							this.$router.push('/login');
						}
					}
				}
			});
		},
		test: function () {
			console.log('Test...');
		},
	},
};

const plaid = {
	data: function () {
		return {
			locale: this.$i18n.locale,
			plaidData: null,
			plaidHandler: null,
			recreate: 0,
		};
	},

	methods: {
		destroyPlaid: function () {
			let handler = this.plaidHandler;
			this.plaidHandler = null;
			handler.destroy();
			this.$store.commit('setLoaderModal', false)
		},
		verification: function (publicToken, accountId) {
			this.$store.commit('setPaymentModal', false)
			this.$http
				.post('user/verification', {
					status: true,
					publicToken,
					accountId,
				})
				.then((data) => {
					// AW

					if (data && data.status !== undefined && data.status) {

						const user = data.data.user;
						this.$setState('userUpdate', user);
						if (user.pr_bank && this.$route.path === '/login') {
							this.$setState('loginActiveStep', 'card');
						}

						if (this.$route.path === '/settings') {
							// this.$emit("goNextCardProcess", "addAnotherCard");
							this.getListBanks();
						}
						if (this.$route.path === '/dashboard') {
							this.$store.commit('setActiveSettings', 'bankAccount')
							this.$router.push('/settings')
						}
						this.destroyPlaid();
						this.$toastr.s('Bank added successfully. ');
					} else {
						this.$toastr.e('Some error occurred.');
						this.$store.commit('setPaymentModal', true)
						this.$emit('goNextCardProcess', 'addAnotherCard');
					}

				});
		},
		reAuthorized: async function () {
			await this.$http.post('user/plaid_reauthorize')
			this.$store.commit('setLoaderModal', false)
			this.$setState('load', 0)
		},
		plaidLoad: function () {
			window.scroll(0, 0);
			console.log(window.Plaid);
			if (window.Plaid === undefined) {
				let plaidScript = document.createElement('script');
				plaidScript.setAttribute('src', 'https://cdn.plaid.com/link/v2/stable/link-initialize.js');
				document.head.appendChild(plaidScript);
				plaidScript.onload = () => {
					this.plaidInit();
				};
			} else {
				this.plaidInit();
			}
		},
		plaidInit: function () {
			console.log('later');
			this.$http
				.get(`user/link/token/create?locale=${this.locale}&id=${this.recreate}`)
				.then((res) => {
					if (res.data.plaid_data && res.data.plaid_data.error_code === undefined) {
						this.plaidData = res.data.plaid_data;
						this.plaidCreate();
					} else {
						this.$toastr.e(`${res.data.plaid_data.error_code}: ${res.data.plaid_data.error_message}`);
						this.$setState('load', 0);
					}
				})
				.catch(() => {
					this.$setState('load', 0);
				});
		},
		plaidCreate: function () {
			const $this = this;
			const handler = Plaid.create({
				token: !!this.plaidData.link_token ? this.plaidData.link_token : '',
				onSuccess: (public_token, metadata) => {
					if (!$this.recreate) {
						this.$store.commit('setLoaderModal', true)
						$this.verification(public_token, metadata.account_id);
					}
					if ($this.recreate && this.$getState('isBankAuthorized')) {
						this.$store.commit('setLoaderModal', true)
						setTimeout(() => {
							$this.reAuthorized()
						}, 2000)
					}
					this.$setState('setBankAuthorization', null)
					$this.recreate = 0;
				},
				onLoad: () => { },
				onExit: (error, metadata) => {
					this.$setState('load', 1);
					if (error && !!error.error_code && !!error.error_message) {
						$this.$toastr.e(`${error.error_code}: ${error.error_message}`);
					} else {
						$this.destroyPlaid();
					}
					$this.$setState('load', 0);
				},
				onEvent: (eventName, metadata) => {
					switch (eventName) {
						case 'HANDOFF':
						case 'EXIT':
							$this.$setState('load', 0);
							break;
					}
				},
				receivedRedirectUri: null,
			});

			this.plaidHandler = handler;

			// Open Link
			handler.open();
		},

	},
};
let address_components = true
const location = {
	methods: {
		getLocation(isAddressComponents) {
			this.$route.path == '/add-location' ? this.$setState('load', 1) : this.$setState('setSpinner', true)
			address_components = isAddressComponents
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
			} else {
				this.$toastr.e('Geolocation is not supported by this browser.');
			}
		},
		async showPosition(position) {
			const latlng = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			}
			this.$setState('userLocation', latlng)
			const geocoder = new google.maps.Geocoder();
			const { results } = await geocoder.geocode({ location: latlng })
			this.$setState('setCurrentLocation', results[0].formatted_address)
			address_components && this.$setState('setAddressWithLatLng', { address: results[0].formatted_address, ...latlng })
			this.$setState('setSpinner', false)
			this.$setState('load', 0)
		},
		showError(error) {
			let msg = ''
			switch (error.code) {
				case error.PERMISSION_DENIED:
					msg = "User denied the request for Geolocation."
					break;
				case error.POSITION_UNAVAILABLE:
					msg = "Location information is unavailable."
					break;
				case error.TIMEOUT:
					msg = "The request to get user location timed out."
					break;
				case error.UNKNOWN_ERROR:
					msg = "An unknown error occurred."
					break;
			}
			this.$setState('load', 0)
			this.$setState('setSpinner', false)
			this.$toastr.e(msg);
		},
		async findPrimaryLocation() {
			const response = await this.$http.get('user/address')
			const savedLocations = response.data
			const primaryAddress = savedLocations.find(l => l.is_primary)
			if (primaryAddress && primaryAddress.id) {
				const latlng = {
					lat: primaryAddress.lat,
					lng: primaryAddress.lng
				}
				const obj = {
					title: primaryAddress.title,
					address: primaryAddress.address,
					...latlng
				}
				this.$setState('setPrimaryLatlng', latlng)
				this.$setState('setAnotherLocation', obj)
				this.$setState('setIsCurrent', false)
			}
			return savedLocations
		}
	}
}
const retailers = {
	methods: {
		async retailersInFiftyMiles(args, callBack, $state) {
			const coords = this.$getState('showGoogleMap') ? this.$getState('userLocation') : this.$getState('primaryLatlng') || this.$getState('userLocation')
			let posts = []
			const payload = {
				...args,
				location: {
					center_lat: coords.lat,
					center_lng: coords.lng,
					dist: 80
				}
			}
			const response = await this.$http.post("retailer/list", payload)
			posts = response.status ? [...response.data.retailers] : []
			callBack(posts, $state)
		},
	}
}
const session = {
	methods: {
		async checkUser () {
      this.$setState('load', 1)
      const { status, data } = await this.$http.post("user/useronline")
      this.$setState('load', 0)
      if(!status) return
      const user = data && data.user
      if (this.$checkUser(user)) {
        this.$router.push("/dashboard");
      }
		}
	}
}

export default {
	npos,
	helpers,
	plaid,
	location,
	retailers,
	session
};
